import { Cancel, KeyboardArrowDown, KeyboardArrowUp, MenuOutlined, Print } from '@mui/icons-material';
import {
  Button as AntdButton,
  Select as AntSelect,
  Button,
  Col,
  Dropdown,
  Row,
  Space,
  Tooltip
} from "antd";
import Loading from "components/Loading";
import StoryWithImages from "components/StoryWithAi/StoryView";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import QnALoader from "components/VocabQnAModal/QnALoader";
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import { get } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useSuperLesson } from "store/SuperLesson/selectors";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import styled from "styled-components";
import { question_type_generate_more } from "utils/config/reference";
import color from "utils/constants/color";
import {
  addPrintableClass,
  removePrintableClass,
} from "utils/methods/textMethod";
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';
const { Option } = AntSelect;
const LessonContainer = styled.section`
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 50;
  top : 0;
`;

const LessonModal = styled.div`
  background: #000f4c;
  padding-left: ${(p) => (p.view ? "51px" : "15px")};
  padding-right: ${(p) => (p.view ? "51px" : "15px")};
  padding-bottom: ${(p) => (p.view ? "34px" : "26px")};
  padding-top: ${(p) => (p.view ? "51px" : "17px")};
  height: ${(p) => (p.view ? "unset" : "98%")};
  // overflow: hidden auto;
  overflow: hidden;
  @media Screen and (max-width: 600px){
    height:96% !important;
  }
  @media Screen and (min-width:801px) and (max-width: 830px){
    height:120% !important;
  }
  @media Screen and (max-width: 425px){
    height: 90% !important;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
`;

const BoxContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 14px;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;
  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
     
    font-weight: 400;
  }
`;

const FieldShareBox = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  width: 100%;
  height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
   
  font-weight: 400;
  flex: 1;
  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
     
    font-weight: 400;
  }
    .ant-select-selection-item{
      text-align:left;
    }
`;


const DropDownOption = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;
  width:100%;
`
const LevelButton = styled(AntdButton)`
  background-color: ${({ active }) => (active ? color.orange200 : '#fff')};
  color: ${({ active }) => (active ? 'white' : 'black')};
  border: none;
  border-radius: 8px;
  cursor: pointer;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
    background-color: ${({ active }) => (active ? color.orange200 : '#fff')} !important;
    color: ${({ active }) => (active ? 'white' : 'black')} !important;
    box-shadow: none !important;
    border: none !important;
  }
`;

const LevelItemList = styled.div`
   background-color: ${({ active }) => (active ? color.orange200  : '#fff')};
  color: ${({ active }) => (active ? 'white' : 'black')};
  border: none;
  border-radius: 2px;
  cursor: pointer;
  padding: 8px 12px;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
    background-color: ${({ active }) => (active ? color.orange200 : '#fff')} !important;
    color: ${({ active }) => (active ? 'white' : 'black')} !important;
    box-shadow: none !important;
    border: none !important;
  }
`;
const ListLevelButton = styled(Button)`
   background-color:rgb(3, 152, 158);
  color:white;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
  background-color:rgb(3, 152, 158);
  color:white;
    box-shadow: none !important;
    border: none !important;
  }
`;


const levelOrder = ["Intermediate-low", "Intermediate-mid", "Intermediate-high"];






const ViewArticleLevels = ({
  open,
  onClose,
  viewLessonType,
  setOpenArticleModalView,
  imageConfiguration,
  chapter ,
  page,
  page_articles
}) => {
  const showAlert = useAlert();
  const imageRef = useRef();
  const formattePageArticledData = useMemo(() => {
    return page_articles.map((item) => ({value: item.id,label: item.articles_title,profency_level: item.config?.proficiencyLevel})).sort((a, b) => {
      const indexA = levelOrder.indexOf(a.profency_level);
      const indexB = levelOrder.indexOf(b.profency_level);
      return indexA - indexB;
    });
  }, [page_articles]);
  const currentUser = useCurrentUser();
  const isCanvasUser = useMemo(() =>  !!get(currentUser,"canvas_id"), [currentUser]);
  const superLesson = useSuperLesson();
  const [showShareList, setShowShareList] = useState(true);
  const [printLoader, setPrintloader] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState();
  const [selectedTypes, setSelectedTypes] = useState(question_type_generate_more.map((option) => option.value));
  const [questionLoader, setQuestionLoader] = useState(false);
  const [assignmentAiModal, setAssignmentAiModal] = useState(false);
  const [generateQnALoader, setGenerateQnALoader] = useState(false);
  const [questionGenerator, setQuestionGenerator] = useState([]);
  const [qnaWord, setQnAWord] = useState("");
  const is_student = useMemo(()=>currentUser?.role=='student',[currentUser])
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const [generatedCount,SetGenerateCount] = useState(0)
  const questionRequestIdRef = useRef(0);
  const selectedProficiencyLevel = useMemo(() => {
    if (selectedArticle) {
      return selectedArticle?.config?.proficiencyLevel
    } else if (Array.isArray(formattePageArticledData) && formattePageArticledData?.length > 0) {
      return formattePageArticledData[0].profency_level
    } return null;
  }, [selectedArticle, formattePageArticledData])
  const width = window.innerWidth;
  const isCompact = width <= 500 || (width >= 809 && width <= 890);
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const [openLanguageDropdown, setOpenLanguageDropdown] = useState(false);

  const handleClickActive = (level) => {
    const currentLevel = level?.profency_level
    onSelectAricle(level?.value)
  };
  const formatProficiencyLevel = (level) => {

    switch (level) {
      case 'Intermediate-low':
        return 'Intermediate Low';
      case 'Intermediate-mid':
        return 'Intermediate Mid';
      case 'Intermediate-high':
        return 'Intermediate High';
      default:
        return level;
    }
  };

  useEffect(() => {
    const article = page_articles[0]||{};
    setSelectedArticle(article);
  }, [page_articles]);

  useEffect(() => {
    if (viewLessonType === "shared") {
      setShowShareList(true);
    }
  }, [superLesson]);



  const isDisable = () => {
    return true;
  };


  const validationPrint = () => {
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!", "error");
      return;
    } else {
      addPrintableClass();
      printCall();
    }
  };
  const printCall = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => {
      setPrintloader(true);
    },
    onBeforePrint:  async () => {
      setPrintloader(false);
    },
    onAfterPrint: async () => {
      removePrintableClass();
    },
  });



  const onGenerateAiActivity = async (language) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate questions.', 'error');
      return;
    }
    if(!selectedArticle?.id) return showAlert("Please select a story!", "error");
    const requestId = questionRequestIdRef.current + 1;
    questionRequestIdRef.current = requestId;
    setAssignmentAiModal(true);
    setGenerateQnALoader(true);
  
    const data = JSON.stringify({
      topic: selectedArticle?.articles_text,
      language: selectedArticle?.config?.language,
      article_id: selectedArticle?.id,
      bookId: selectedArticle?.chapter,
      story_proficiency: selectedArticle?.config?.proficiencyLevel,
      question_language: language
    });

    try {
      await handleStreamResponse({
        path: "ai/generate/generate-questions-for-story",
        body: data,
        onTitle: (title) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQnAWord(title)
          SetGenerateCount(0)
        },
        onQuestion: (question) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
          SetGenerateCount(prev => prev + 1)
          setQuestionLoader(false);
          setGenerateQnALoader(false);
        },
        onDone: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        },
        onError: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        }
      })
    } catch (error) {
      setAssignmentAiModal(true);
      setGenerateQnALoader(true);
    }
  };

  const handleGenerateMoreQnA = async (topic,languageKey = null) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate questions.', 'error');
      return;
    }
    const requestId = questionRequestIdRef.current + 1;
    questionRequestIdRef.current = requestId;
    setQuestionLoader(true);
    try {
      const data = JSON.stringify({
        topic: selectedArticle?.articles_text,
        language: selectedArticle?.config?.language,
        question_type: selectedTypes,
        article_id: selectedArticle?.id,
        bookId: selectedArticle?.chapter,
        story_proficiency: selectedArticle?.config?.proficiencyLevel,
        question_language: languageKey ? languageKey :'spanish'
      })
      await handleStreamResponse({
        path: "ai/generate/generate-questions-for-story",
        body: data,
        onTitle: (title) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQnAWord(title)
          SetGenerateCount(0)
        },
        onQuestion: (question) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
          SetGenerateCount(prev => prev + 1)
          setQuestionLoader(false);
          setGenerateQnALoader(false);
        },
        onDone: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        },
        onError: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        }
      })
    } catch (error) {
      setAssignmentAiModal(true);
      setGenerateQnALoader(true);
      setQuestionLoader(false);
    }
    setQuestionLoader(false);
  };

  const handleForDistrictAdmin = () => {
    if (currentUser.role === 'admin') {
      showAlert("Please login as teacher!", "error");
      return true;
    }
    return false;
  };




  // const generated_question = useMemo(() =>questionGenerator.map((k) => ({ ...k, id: Math.random() * 1000000000 })),[questionGenerator]);
    const ArticleLabel = (item) => {
        const { label = '-', value, profency_level } = item;
        let drop_label = label || ''
        const cat_len_large = drop_label.length > 40;
        const profency_level_title = profency_level ? `(${profency_level})` : ''
        drop_label += profency_level_title
        return (<Option key={value} value={value} label={drop_label}>
            <DropDownOption>
                <Tooltip title={cat_len_large ? drop_label : null} >
                    <span>
                        {cat_len_large ? drop_label?.slice(0, 40) + "..." : drop_label}
                    </span>
                </Tooltip>
            </DropDownOption>
        </Option>)
    }
  const onSelectAricle = (value) => {
        const article = page_articles?.find((story) => story.id === value);
        setSelectedArticle(article);
  }
  const RenderMenuContent = () => {
    return {
      items: formattePageArticledData.map((item) => ({
        key: item.value,
        label: (
          <LevelItemList
            active={selectedProficiencyLevel === item.profency_level}
            className="ulLitItmeList"
            onClick={() => handleClickActive(item)}
          >
            {formatProficiencyLevel(item?.profency_level)}
          </LevelItemList>
        )
      }))
    };
  };

  const languageMenuItems = [
    {
      key: 'spanish',
      label: 'Spanish',
      onClick:() => {
        if(handleForDistrictAdmin()) return;
        onGenerateAiActivity('spanish');
      }
    },
    {
      key: 'english',
      label: 'English',
      onClick:() => {
        if(handleForDistrictAdmin()) return;
        onGenerateAiActivity('english');
      }
    }
  ];

  return (
    <SentryWrap>
      {open && (
        <LessonContainer isCanvasUser={isCanvasUser}>
          <LessonModal
            style={{ position: "relative" }}
            view={viewLessonType === "shared" && showShareList ? true : false}
          >
            <span
              style={{position:"absolute",top:10,right:10}}
              onClick={() => {
                onClose();
                updatePopUpAtOnce(false);
              }}
            >
              <Cancel
                style={{
                  float: "right",
                  fontSize:
                    viewLessonType === "shared" && showShareList ? 25 : 18,
                  color: "red",
                  background: "white",
                  borderRadius: 20,
                  cursor: "pointer",
                  marginBottom: 5,
                }}
              />
            </span>
            <Container>
              <div className={isCanvasUser ? "canvasSuperLessonContainer" : "widthStoryCont"} style={{ width:"98%"}}>
              {!is_student?<BoxContainer
                  className={
                    isCanvasUser ? "canvasSuperLessonBoxContainer" : ""
                  }
                  style={{
                    marginRight: 6,
                    marginBottom: 12,
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  {/* <Label style={{position:'absolute',top:13,zIndex:9}}>Levels</Label> */}
                  <Dropdown menu={{items: languageMenuItems}} trigger={['click']} open={openLanguageDropdown} onOpenChange={setOpenLanguageDropdown}>
                  <div
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        // type="primary"
                        disabled={!isDisable()}
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "white",
                          cursor: isDisable() ? "pointer" : "not-allowed",
                          backgroundColor: isDisable() ? "#03989e" : "#b3b3b3",
                        }}
                      >
                        {"Generate AI Activity 1"}
                        {openLanguageDropdown ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </AntdButton>
                    </span>
                  </div>
                  </Dropdown>
                 
                  <div
                    style={{ cursor: "pointer", width: "50px" }}
                    onClick={() => {
                      if(handleForDistrictAdmin()) return;
                      validationPrint();
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        // type="primary"
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                          backgroundColor:"#03989e"
                        }}
                      >
                        {printLoader ? <Loading size={20} white /> : <Print style={{ color: 'white' }} />}
                      </AntdButton>
                    </span>
                  </div>

                  {isCompact && (
                    <Dropdown menu={RenderMenuContent()} trigger={['click']}>
                      <ListLevelButton style={{ display: 'flex', alignItems: 'center' }} className="levelListBtn">
                          <MenuOutlined />
                      </ListLevelButton>
                    </Dropdown> 
                  )}
                </BoxContainer> : null}
                {is_student && (
                  isCompact && (
                    <Dropdown menu={RenderMenuContent()} trigger={['click']}>
                      <ListLevelButton style={{ display: 'flex', alignItems: 'center' }} className="levelListBtn">
                        <MenuOutlined />
                      </ListLevelButton>
                    </Dropdown>
                  )
                )}
                <BoxContainer
                  className={
                    isCanvasUser ? "canvasSuperLessonBoxContainer" : ""
                  }
                  style={{
                    marginRight: 6,
                    // marginLeft: 13,
                    marginBottom: 12,
                    position:'relative'
                  }}
                >
                  {!isCompact && 
                  <Row
                    style={{
                      width: '100%',
                    }}
                  > 
                    <Col span={24}
                      lg={12}
                      sm={24} 
                      xs={24} >
                      <FieldShareBox
                        style={{
                          background: "none",
                          flex: "1",
                          border: "none",
                          placeItems: "start",
                        }}
                      >
                        <Space direction="horizontal" style={{ width: "100%" }}>
                          {formattePageArticledData.map((item) => <LevelButton key={item.value}
                            active={selectedProficiencyLevel === item.profency_level}
                            onClick={() => handleClickActive(item)}>
                            {formatProficiencyLevel(item?.profency_level)}
                          </LevelButton>)}
                        </Space>
                      </FieldShareBox>
                    </Col>
                  </Row>
                   } 
                </BoxContainer>
              </div>
            </Container>
            <StoryWithImages
              imageConfiguration={imageConfiguration}
              ref={imageRef} 
              images={selectedArticle?.images  || []}
              text={selectedArticle ? selectedArticle?.articles_text : ""}
              title={selectedArticle?.articles_title || ''}
              storyInfo={selectedArticle|| {}}
              is_student={is_student}
              enable_student_share={false}
              isLevel
              />
          </LessonModal>
        </LessonContainer>
      )}
      {assignmentAiModal && (
        <QnALoader
          assignmentAiModal={assignmentAiModal}
          setAssignmentAiModal={(val) => {
            if (!val) {
              questionRequestIdRef.current += 1;
              // setQuestionGenerator([]);
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0);
            }
            setAssignmentAiModal(val);
            setOpenArticleModalView(val);
          }}
          handleGenerateMoreQnA={handleGenerateMoreQnA}
          generateQnALoader={generateQnALoader}
          questionGenerator={questionGenerator}
          page={selectedArticle ? selectedArticle?.page : page ||  ""}
          chapter={
            selectedArticle ? selectedArticle?.chapter : chapter || ""
          }
          qnaWord={qnaWord}
          loading={questionLoader}
          assignmentTitle={qnaWord}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
          storyInstruction={null}
          article_level_id={selectedArticle?.id}
          generatedCount={generatedCount}
        />
      )}
    </SentryWrap>
  );
};

export default ViewArticleLevels;
